<div *transloco="let t; read: 'features.validateCoupon'">
  <div class="modal-header">
    <h5 class="modal-title">{{ t("title") }}</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="dismiss()"></button>
  </div>

  <div class="modal-body">
    <div class="mb-4">
      <app-coupon-search-form
        [loading]="loading"
        [hasDetails]="viewState === 'details'"
        [scannedCode]="scannedCode"
        (search)="search($event)"
        (scan)="scan($event)"
      >
      </app-coupon-search-form>

      <app-coupon-details
        *ngIf="viewState === 'details'"
        [couponList]="couponList"
        [isRedeemed]="isRedeemed"
        [selectedCoupon]="selectedCoupon"
        (couponChange)="onCouponChange($event)"
      >
      </app-coupon-details>

      <div class="spinner-wrapper" *ngIf="viewState === 'loading'">
        <span class="spinner-border spinner-border-sm mr-1"> </span>
      </div>
    </div>

    <div *ngIf="!isRedeemed" class="modal-footer inner two-actions">
      <lib-qr-code-reader-button
        class="btn p-0"
        [buttonText]="'qrcode.scan' | transloco"
        [isButtonDisabled]="viewState !== 'search'"
        (scanModalOpened)="onScanModalOpened()"
        (scanResult)="scan($event)"
      >
      </lib-qr-code-reader-button>

      <button
        type="button"
        class="btn btn-main"
        [ngbTooltip]="'common.controls.validate' | transloco"
        [class.disabled]="!selectedCoupon || loading || selectedCoupon?.status !== CouponCodeItemStatus.Issued"
        #tooltip="ngbTooltip"
        (click)="validate(); tooltip.close()"
      >
        {{ "common.controls.validate" | transloco }}
      </button>
    </div>

    <div *ngIf="isRedeemed" class="modal-footer inner">
      <button type="button" class="btn btn-main w-100" (click)="dismiss()">
        {{ t("backToHome") }}
      </button>
    </div>
  </div>
</div>
